import { CardBackgroundViewModel } from '../../card-background-view-model';
import { Injectable } from '@angular/core';

@Injectable()
export class MissJonesCardStackBackgroundViewModel extends CardBackgroundViewModel {}
